function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React, { forwardRef, useContext } from "react";
import { useStyle } from "./Scrim.styles";
import { injectTestId } from "@cvent/nucleus-test-automation";
import { CarinaContext } from "../CarinaProvider";
import { ZIndexContext } from "../ZIndexProvider";
var Scrim = forwardRef(function(_param, forwardedRef) {
    var tmp = _param.zIndex, zIndexIn = tmp === void 0 ? 1 : tmp, testID = _param.testID, rest = _objectWithoutProperties(_param, [
        "zIndex",
        "testID"
    ]);
    var ref;
    var flags = ((ref = useContext(CarinaContext)) !== null && ref !== void 0 ? ref : {
        flags: {
            zIndexUpdates: false
        }
    }).flags;
    var zIndexUpdates = flags.zIndexUpdates;
    var ref1;
    var getScrimZIndex = ((ref1 = useContext(ZIndexContext)) !== null && ref1 !== void 0 ? ref1 : {}).getScrimZIndex;
    var ref2;
    var zIndex = (ref2 = zIndexUpdates ? getScrimZIndex === null || getScrimZIndex === void 0 ? void 0 : getScrimZIndex() : zIndexIn) !== null && ref2 !== void 0 ? ref2 : 1;
    var scrimStyles = useStyle({
        zIndex: zIndex
    });
    var builtCSS = [
        scrimStyles.base
    ];
    return _jsx("div", _objectSpread({}, rest, injectTestId(testID), {
        css: builtCSS,
        ref: forwardedRef
    }));
});
export { Scrim };
export default Scrim;
